import { DataTable } from '@creditornot/cb-data-table';
import { Lock as LockIcon } from '@creditornot/cb-icons';
import { colors } from '@creditornot/cb-ingredients';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { SftpIntegrationUser } from 'apis/merchant-gateway/pos-integration-service/sftp-integration/types';

import DeleteSshKeyModal from './DeleteSshKeyModal';
import SshKeyContextMenu from './SshKeyContextMenu';

type Props = {
  sftpIntegrationUser: SftpIntegrationUser;
  merchantId: string;
  onDelete: () => void;
};

const StyledLockIcon = styled(LockIcon)`
  fill: ${colors.wolt72};
  width: 16px;
  margin-inline-end: 8px;
`;

type ModalState = {
  keyId: string | null;
  isOpen: boolean;
};

const SftpUserSshKeys = ({ sftpIntegrationUser, onDelete, merchantId }: Props) => {
  const intl = useIntl();
  const [modalState, setModalState] = useState<ModalState>({
    keyId: null,
    isOpen: false,
  });

  return (
    <>
      <DataTable
        dataSource={sftpIntegrationUser.ssh_keys || []}
        getRowKey={record => record.key_id}
        horizontalPadding="wide"
        columns={[
          {
            id: 'key_id',
            name: intl.formatMessage({ id: 'merchant-integrations.sftp.ssh-key-id' }),
            render: ({ record }) => {
              return (
                <>
                  <StyledLockIcon></StyledLockIcon>
                  {record.key_id}
                </>
              );
            },
          },
          {
            id: 'actions',
            name: 'Actions',
            renderName: false,
            alignContent: 'right',
            render: ({ record }) => {
              return (
                <SshKeyContextMenu
                  onDelete={async () => {
                    setModalState({ keyId: record.key_id, isOpen: true });
                  }}
                />
              );
            },
          },
        ]}
      />

      {modalState.keyId && (
        <DeleteSshKeyModal
          isOpen={modalState.isOpen}
          onClose={() => {
            setModalState({ keyId: null, isOpen: false });
          }}
          merchantId={merchantId}
          keyId={modalState.keyId}
          onDelete={() => {
            setModalState({ keyId: null, isOpen: false });
            onDelete();
          }}
        />
      )}
    </>
  );
};

export default SftpUserSshKeys;
